"use client";

import { strings } from "@perceptron/constants";
import { cn } from "@perceptron/utils/cn";

import { useActiveTab } from "./ActiveTabContext";

const MobileTabs = () => {
  const { activeTab, setActiveTab } = useActiveTab();

  return (
    <div className="relative z-0 mt-2 flex shrink-0 cursor-pointer items-center justify-between rounded-full bg-background-accent p-1 sm:hidden">
      <div
        className={cn(
          "absolute left-1 top-1 h-[calc(100%-8px)] w-[calc(50%-4px)] rounded-full bg-background transition-transform",
          {
            "translate-x-0": activeTab === "input",
            "translate-x-full": activeTab === "output",
          },
        )}
      />
      <div
        className="z-10 flex w-full items-center justify-center py-2"
        role="button"
        tabIndex={0}
        onClick={() => setActiveTab("input")}
      >
        {strings.navigation.tabs.prompt}
      </div>
      <div
        className="z-10 flex w-full items-center justify-center py-2"
        role="button"
        tabIndex={0}
        onClick={() => setActiveTab("output")}
      >
        {strings.navigation.tabs.output}
      </div>
    </div>
  );
};

export default MobileTabs;
